import { graphql } from 'gatsby';
import React from 'react';

import { useGetLibraryDictionary } from '../../../hooks/use-get-library-dictionary';
import { ILibraryOpeningHours } from '../../../queries/fragments/libraryOpeningHours';
import { ILibraryOpeningHoursException } from '../../../queries/fragments/libraryOpeningHoursException';
import { OpeningHours } from '../../opening-hours/opening-hours';

export interface MeetingPlaceOpeningHoursBlockProps {
  node_locale: string;
  meetingPlaceOpeningHours?: {
    openingHours?: ILibraryOpeningHours;
    openingHoursExceptions?: ILibraryOpeningHoursException[];
    timezone?: string;
  };
}
const MeetingPlaceOpeningHoursBlock = ({
  node_locale,
  meetingPlaceOpeningHours,
}: MeetingPlaceOpeningHoursBlockProps) => {
  const dictionary = useGetLibraryDictionary(node_locale);

  return (
    <>
      {meetingPlaceOpeningHours && meetingPlaceOpeningHours?.openingHours && (
        <OpeningHours
          node_locale={node_locale}
          openingHours={meetingPlaceOpeningHours?.openingHours}
          variant="block-compact-exceptions"
          openingHoursClosed={dictionary?.openingHoursClosed ?? ''}
          openingHoursClosedToday={dictionary?.openingHoursClosedToday ?? ''}
          openingHoursExceptions={
            meetingPlaceOpeningHours?.openingHoursExceptions ?? []
          }
          openingHoursOpenToday={dictionary?.openingHoursOpenToday ?? ''}
          timezone={meetingPlaceOpeningHours?.timezone ?? ''}
          openingHoursBlockExceptionTitle={
            dictionary?.openingHoursBlockExceptionTitle
          }
        />
      )}
    </>
  );
};

export default MeetingPlaceOpeningHoursBlock;

export const query = graphql`
  fragment BlockMeetingPlaceOpeningHours on ContentfulBlockMeetingPlaceOpeningHours {
    blocktype: __typename
    id
    node_locale
  }
`;
